<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-01 02:16:12
    Description : gaia页面header
  -->
  <div class="header-background">
    <div class="header">
      <div class="logo">
        <img
          class="logo-img"
          src="../../assets/images/logo/gaia-logo26.png"
          @click="jumpTo('/', true)"
        />
        <div class="title">电影创作者家园</div>
      </div>
      <div
        class="link-item"
        @click="jumpTo('/desktop/gaia-material/list', true)"
      >
        素材
      </div>
      <div class="link-item" @click="jumpTo('/works/list', true)">作品</div>
      <div class="link-item" @click="jumpTo('/works/HDR/list', true)">HDR</div>
      <div class="link-item" @click="jumpTo('/works/show/list', true)">
        展映
      </div>
      <div class="link-item" @click="jumpTo('/group/group/list', true)">
        创作组
      </div>
      <div
        class="link-item"
        @click="jumpTo('/college/private/collegeIndex', true)"
      >
        学院
      </div>
      <div class="link-item" @click="jumpTo('/desktop/gaia-48/main', true)">
        Gaia48
      </div>
<!--      <div class="link-item" @click="jumpTo('/teamwork/frame/main', true)">-->
<!--        frame-->
<!--      </div>-->
      <div class="link-item" @click="jumpTo('https://sweb.media/')">
        SWeb（测试)
      </div>
      <div
        class="upload"
        v-if="isLogin"
        :style="{ visibility: !isShowUpload ? 'hidden' : '' }"
      >
        <img :src="uploadBtn" @click="$emit('upload')" />
      </div>
      <div
        class="avatar"
        v-if="isLogin"
        @mouseenter="avatarShow = true"
        @mouseleave="avatarShow = false"
      >
        <el-avatar :size="30" :src="avatar">
          <img :src="VUE_APP_DEFAULTAVATAR" />
        </el-avatar>
      </div>
      <div
        class="shopping"
        v-if="isLogin"
        @mouseenter="shopcartShow = true"
        @mouseleave="shopcartShow = false"
      >
        <img :src="shoppingBtn" @click="jumpTo2('/shopping-cart')" />
      </div>
      <div v-if="!isLogin" class="loginBox">
        <el-link :underline="false" @click="register"> 注册 </el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link :underline="false" @click="jumpTo('/account/login', true)">
          登录
        </el-link>
      </div>
    </div>
    <div
      class="dialog"
      v-show="avatarShow"
      @mouseenter="avatarShow = true"
      @mouseleave="avatarShow = false"
    >
      <div class="self-card">
        <el-avatar :size="60" :src="avatar">
          <img :src="VUE_APP_DEFAULTAVATAR" />
        </el-avatar>
        <div class="title">
          <div class="name">{{ nickname }}</div>
          <div class="job">{{ job }}</div>
        </div>
      </div>
      <el-divider></el-divider>
      <div style="display: flex; margin-bottom: 80px">
        <div
          class="icon-btn"
          @click="jumpTo('/account/private/userInfo', true)"
        >
          <i class="el-icon-user-solid"></i>
          <div>帐户管理</div>
        </div>
        <div class="icon-btn" @click="jumpTo(`/personal/index/${id}`, true)">
          <i class="el-icon-s-tools"></i>
          <div>创作管理</div>
        </div>
      </div>
      <div class="logout">
        <el-link :underline="false" style="width: 100%" @click="logout"
          >退出登录</el-link
        >
      </div>
    </div>
    <div
      class="dialog"
      v-show="shopcartShow"
      @mouseenter="shopcartShow = true"
      @mouseleave="shopcartShow = false"
    >
      <div class="shopping-card">
        <div class="list">
          <div class="shopping-none" v-if="shoppingList.length === 0">
            购物车暂无内容
          </div>
          <el-scrollbar style="height: 100%">
            <shoppingCart-item
              v-for="(item, i) in shoppingList"
              :key="i"
              :data="item"
            />
          </el-scrollbar>
        </div>
        <el-button
          type="primary"
          v-if="shoppingList.length > 0"
          size="small"
          style="margin-top: 10px; width: 126px"
          @click="jumpTo2('/shopping-cart')"
        >
          立即结算 {{ shoppingList.length }}
        </el-button>
        <div class="item">
          <i class="el-icon-shopping-cart-2"></i>
          <span>购物车</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="item">
          <i class="el-icon-s-order"></i>
          <span>订单中心</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="item">
          <i class="el-icon-date"></i>
          <span>收支明细</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shoppingCartItem from "@/components/shoppingCart-item/shoppingCart-item";
import {
  getWorksShoppingCartList,
  getCollegeShoppingCartList,
  getOrderShoppingCartList,
  getShoppingCartList,
} from "@/api/order";
export default {
  name: "gaia-header",
  components: {
    shoppingCartItem,
  },
  props: {
    isShowUpload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      uploadBtn:
        "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/header_popup_ic_up_n.png",
      shoppingBtn:
        "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/header_popup_ic_bigcart_n.png",
      avatar: "",
      nickname: "",
      job: "",
      id: "",
      avatarShow: false,
      shopcartShow: false,
      time: null,
      VUE_APP_DEFAULTAVATAR: process.env.VUE_APP_DEFAULTAVATAR,
      VUE_APP_RESOURCES_URL: process.env.VUE_APP_RESOURCES_URL,
      shoppingList: [],
      isLogin: false,
    };
  },
  created() {
    // 判断是否登录
    let user = localStorage.getItem("user");
    if (user && document.cookie.includes("user_login_token")) {
      this.isLogin = true;
      user = JSON.parse(user);
      // console.log(user);
      this.avatar = this.VUE_APP_RESOURCES_URL + user.avatar;
      this.nickname = user.nickname;
      this.job = user.job;
      this.id = user.account.id;
      this.getShoppingCart();
    } else {
      this.isLogin = false;
      console.log("未登录");
    }
  },
  methods: {
    /**
     * 获取购物车商品, 包括作品 教程 会员
     */
    getShoppingCart() {
      const order = new Promise((resolve) => {
        getOrderShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const works = new Promise((resolve) => {
        getWorksShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const college = new Promise((resolve) => {
        getCollegeShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      const material = new Promise((resolve) => {
        getShoppingCartList().then((res) => {
          resolve(res);
        });
      });
      Promise.all([order, works, college, material]).then((res) => {
        const order = res[0].memberShoppingCart;
        const works = res[1].worksShoppingCartBOS;
        const college = res[2].courseShoppingCartBOS;
        const material = res[3].materialShoppingCarts;
        if (order) {
          this.shoppingList.push(order);
        }
        if (college) {
          college.map((el) => {
            this.shoppingList.push(el);
          });
        }
        if (works) {
          works.map((el) => {
            this.shoppingList.push(el);
          });
        }
        if (material) {
          material.map((el) => {
            this.shoppingList.push(el);
          });
        }
        // 冒泡排序, 根据添加时间排序
        const list = this.shoppingList;
        for (let j = 0; j < list.length; j++) {
          let done = true;
          let max = list.length - 1;
          for (let i = 0; i < max - j; i++) {
            if (
              new Date(list[i].createTime).valueOf() <
              new Date(list[i + 1].createTime).valueOf()
            ) {
              let temp = list[i];
              list[i] = list[i + 1];
              list[i + 1] = temp;
              done = false;
            }
          }
          if (done) {
            break;
          }
        }
        list.map((el, i) => {
          if (el.works) {
            list[i].name = el.works.title;
            if (el.works.cover) {
              list[i].cover = el.works.cover;
            } else {
              el.works.video.resources.map((el) => {
                if (el.resourceKey && el.resourceKey.includes("180.png")) {
                  list[i].cover = el.resourceKey;
                }
              });
            }
          } else if (el.course) {
            list[i].name = el.course.title;
            list[i].cover = el.course.cover;
          }
        });
        // log(JSON.parse(JSON.stringify(list)));
      });
    },
    /**
     * 非router跳转路由
     */
    jumpTo(url, self = false) {
      if (self) {
        location.href = url;
      } else {
        window.open(url);
      }
    },
    jumpTo2(url) {
      this.$router.push(url);
    },
    /**
     * 注册
     */
    register() {
      localStorage.setItem("way", "register");
      this.jumpTo("/account/login", true);
    },
    /**
     * 退出登录, 并且回到首页
     */
    logout() {
      document.cookie = "";
      localStorage.removeItem("user");
      this.jumpTo("/", true);
    },
  },
};
</script>

<style lang="less">
.header-background {
  position: fixed;
  width: 100%;
  min-width: 1300px;
  height: 70px;
  background: #ffffff;
  // box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  z-index: 100;
}
</style>
<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;
  width: 1300px;
  height: 70px;
  left: 0;
  right: 0;
  padding: 22px 50px;
  margin: 0 auto;
  background: #ffffff;
  box-sizing: border-box;
  z-index: 100;
}
.logo {
  display: flex;
  width: 304px;
  .logo-img {
    display: block;
    width: 182px;
    height: 26px;
    cursor: pointer;
  }
  .title {
    color: #717171;
    font-size: 12px;
    padding: 4px 15px;
  }
}
.link-item {
  margin: 0px 15px;
  height: 56px;
  line-height: 56px;
  color: #717171;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.link-item:hover {
  border-bottom: solid 4px #f79c9f;
}
.upload {
  margin-left: 70px;
  cursor: pointer;
}
.avatar {
  margin: 0 40px;
  text-align: center;
  cursor: pointer;
}
.shopping {
  cursor: pointer;
}
.dialog {
  position: absolute;
  top: 52px;
  right: 10%;
  width: 410px;
  height: auto;
  background: #ffffff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  padding: 20px 20px 0;
  box-sizing: border-box;
  z-index: 10000;
}
.self-card {
  display: flex;
  align-items: center;
  margin-top: 20px;
  .title {
    margin-left: 20px;
    color: #333;
    font-weight: 700;
    font-size: 16px;
    .name {
      height: 30px;
    }
    .job {
      color: #999;
      font-size: 14px;
    }
  }
}
.loginBox {
  width: 220px;
  text-align: right;
  .el-link--inner {
    font-size: 12px;
  }
}
.logout {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 36px;
}
.icon-btn {
  text-align: center;
  width: 16%;
  font-size: 14px;
  color: #666;
  margin-right: 24%;
  cursor: pointer;
  i {
    font-size: 40px;
    margin-bottom: 10px;
    color: #999999;
  }
}
.shopping-card {
  .list {
    height: 480px;
  }
  .item {
    color: #999999;
    margin: 10px 0;
    width: 100%;
    cursor: pointer;
    i {
      font-size: 24px;
    }
    span {
      font-weight: 700;
      color: #616161;
      font-size: 14px;
      margin-left: 10px;
    }
    .el-icon-arrow-right {
      float: right;
      font-size: 20px;
      margin-top: 6px;
    }
  }
  .shopping-none {
    font-size: 14px;
    color: #666;
    padding: 20px;
  }
}
</style>
<style lang="less">
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
</style>
